import gql from 'graphql-tag'

const column = (key, label, sortable = true) => ({ key, label, sortable })
const email = column('email', 'อีเมล', false)
const createdAt = column('createdAt', 'สร้างเมื่อ')
export const logPages = {
  eventLog: {
    permission: 'SystemEventLog',
    columns: [
      email,
      createdAt,
      column('ipAddress', 'IP Address'),
      column('method', 'เมธอด'),
      column('message', 'ข้อความ'),
    ],
    filters: [
      column('ipAddress', 'IP Address'),
      column('method', 'เมธอด'),
      column('logLevel', 'ระดับ Log'),
      column('errorCode', 'รหัสข้อผิดพลาด'),
    ],
    fields: 'ipAddress method message logLevel errorCode payload',
    payload: true,
  },
  loginLog: {
    permission: 'SystemLoginLog',
    columns: [
      email,
      createdAt,
      column('type', 'ประเภท'),
      column('status', 'สถานะ'),
    ],
    filters: [
      {
        key: 'type',
        label: 'ประเภท',
        options: [
          'SignIn',
          'SignOut',
          'SignInWithToken',
          'SignInDummy',
          'SignInStudentApp',
          'SignInDummyStudentApp',
          'VerifyUser',
        ],
      },
      { key: 'status', label: 'สถานะ', options: ['Passed', 'Failed'] },
    ],
    fields: 'type status',
  },
  transactionLog: {
    permission: 'SystemTransactionLog',
    columns: [
      email,
      createdAt,
      column('action', 'การดำเนินการ'),
      column('method', 'เมธอด'),
      column('type', 'ประเภท'),
    ],
    filters: [
      column('action', 'การดำเนินการ'),
      column('method', 'เมธอด'),
      column('type', 'ประเภท'),
    ],
    fields: 'action method type payload',
    payload: true,
  },
  importLog: {
    permission: 'SystemImportLog',
    columns: [
      email,
      column('importCode', 'รหัสนำเข้า'),
      column('importType', 'ประเภทนำเข้า'),
      column('fileName', 'ชื่อไฟล์'),
      column('success', 'สำเร็จ/ทั้งหมด', false),
      createdAt,
      column('status', 'สถานะ', false),
    ],
    filters: [
      column('importCode', 'รหัสนำเข้า'),
      column('importType', 'ประเภทนำเข้า'),
      column('fileName', 'ชื่อไฟล์'),
      {
        key: 'status',
        label: 'สถานะ',
        options: [
          { value: 'true', label: 'ปกติ' },
          { value: 'false', label: 'ยกเลิก' },
        ],
      },
    ],
    fields: 'importCode importType fileName success row status payload',
    payload: true,
  },
}
export function logQuery(kind) {
  if (!Object.prototype.hasOwnProperty.call(logPages, kind))
    throw new Error('Unknown log page')
  return gql`query SystemLogPage($kind: SystemLogKind!, $page: Int!, $pageSize: Int!, $filter: SystemLogFilter, $sortBy: String!, $sortDirection: String!) {
    getSystemLogPage(kind: $kind, page: $page, pageSize: $pageSize, filter: $filter, sortBy: $sortBy, sortDirection: $sortDirection) {
      total page pageSize
      items { id email createdAt ${logPages[kind].fields} }
    }
  }`
}
export function emptyFilter(kind) {
  const filter = { search: '', email: '', dateFrom: '', dateTo: '' }
  logPages[kind].filters.forEach((field) => {
    filter[field.key] = ''
  })
  return filter
}
